import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

// HTML element used for cell styling to create stripped table
export const StyledTableCellHeader = withStyles(theme => ({
    head: {
      // backgroundColor: '#3e8aa5',
      color: '#444a52',
      fontSize: '1.4rem',
      borderRadius: 0,
      borderColor: '#e4e9f0',
      borderWidth: 1,
      borderStyle: 'solid'
    },
    body: {
      fontSize: 14,
      borderRadius: 0
    },
}))(TableCell);

// HTML element used for cell styling to create stripped table
export const StyledTableCell = withStyles(theme => ({
    head: {
      // backgroundColor: '#3e8aa5',
      fontSize: '1.4rem',
      borderRadius: 0
    },
    body: {
      fontSize: 14,
      borderRadius: 0
    },
}))(TableCell);
  
// export default function StyledTableCell(props) {
//     return StyledTableCellObject;
// }
// export default StyledTableCell;